(function () {
  function init(root) {
    if (!root || root.dataset.ogcAboutReady === 'true') return;
    root.dataset.ogcAboutReady = 'true';

    var els = root.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-visible'); });
    }

    if (window.lucide) window.lucide.createIcons();
    else window.addEventListener('load', function () {
      if (window.lucide) window.lucide.createIcons();
    }, { once: true });
  }

  function boot() {
    document.querySelectorAll('[data-ogc-about-page]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
